/**
 * @file `GET /families/{familyId}/study/schedule` のクライアント。
 * @what: 娘用カレンダーから写した「時間配分の計画」スナップショット (家族単位・読み取り専用)。
 * @why: 正本はカレンダー。いちごスタディは計画としてながめるだけで、書き込み API は無い
 *   (同期は CLI)。件名 → 領域の対応づけは model/scheduleMap が行う。
 * @failure: GET は未同期なら 404 → `null` を返す (セクションごと非表示にする)。他は ApiError。
 */

import { ApiError, apiFetch } from "@/shared/api/client";

export interface StudyScheduleBlock {
  date: string;
  start: string;
  minutes: number;
  label: string;
}

export interface StudySchedule {
  schema_v: number;
  calendar_name: string;
  window_start: string;
  window_end: string;
  blocks: StudyScheduleBlock[];
  created_at: string;
  updated_at: string;
}

export async function fetchStudySchedule(
  familyId: string,
  signal?: AbortSignal,
): Promise<StudySchedule | null> {
  try {
    return await apiFetch<StudySchedule>(
      `/families/${encodeURIComponent(familyId)}/study/schedule`,
      signal ? { signal } : {},
    );
  } catch (err) {
    if (err instanceof ApiError && err.status === 404) {
      return null;
    }
    throw err;
  }
}

/** 90 → "1時間30分"、60 → "1時間"、45 → "45分"。 */
export function formatMinutes(minutes: number): string {
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  if (h === 0) return `${m}分`;
  if (m === 0) return `${h}時間`;
  return `${h}時間${m}分`;
}
